<div class="destaque-section">
  <div class="destaque-header">
    <div class="destaque-info">
      <span class="destaque-titulo">{{ texts.categoria_destaque }}</span>
      <p-badge [value]="texts.novo" severity="info" styleClass="ml-2"></p-badge>
      <span class="destaque-contador ml-2">{{ contadorDestaques }}</span>
    </div>
    <div class="destaque-actions">
      <button pButton
              type="button"
              [label]="'+ ' + texts.adicionar_destaque"
              class="p-button-text p-button-sm"
              (click)="adicionarDestaque.emit()">
      </button>
      <button pButton
              type="button"
              icon="pi pi-eye"
              class="p-button-rounded p-button-text p-button-sm"
              (click)="toggleVisibilidade.emit()">
      </button>
      <button pButton
              type="button"
              icon="pi pi-arrow-up"
              class="p-button-rounded p-button-text p-button-sm"
              (click)="moverCima.emit()">
      </button>
      <button pButton
              type="button"
              icon="pi pi-arrow-down"
              class="p-button-rounded p-button-text p-button-sm"
              (click)="moverBaixo.emit()">
      </button>
    </div>
  </div>
</div>
